var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "record-history" }, [
    _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.24rem" },
      },
      [
        _c(
          "div",
          { staticClass: "spaceLeft" },
          [
            _c("div", { staticClass: "page-title" }, [
              _vm._v("Bridge History"),
            ]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "refresh-btn",
                attrs: { icon: "el-icon-refresh", loading: _vm.loading },
                on: { click: _vm.getList },
              },
              [_vm._v("\n        Refresh\n      ")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "spaceLeft search-form" },
          [
            _c("search-select", {
              attrs: { label: "Token Type", options: _vm.tokenOptions },
              on: {
                valChange: function ($event) {
                  return _vm.valChange($event, "token")
                },
              },
            }),
            _vm._v(" "),
            _c("search-select", {
              attrs: { label: "Status", options: _vm.statusOptions },
              on: {
                valChange: function ($event) {
                  return _vm.valChange($event, "status")
                },
              },
            }),
          ],
          1
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "common-card-main common-card is-border" },
      [
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            staticClass: "common-table",
            attrs: { data: _vm.tableList },
          },
          [
            _c("el-table-column", {
              attrs: { prop: "sourcechainid", label: "From", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "chain-info" }, [
                        _c("img", {
                          staticClass: "chain-icon",
                          attrs: { src: _vm.getChainIcon(row.sourcechainid) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "chain-details" }, [
                          _c("div", { staticClass: "chain-name" }, [
                            _vm._v(
                              _vm._s(
                                row.sourcechainid == "6666"
                                  ? "Treasurenet"
                                  : "Ethereum"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "token-amount" },
                            [
                              _c("big-number", {
                                attrs: { number: row.transferAmount },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "token-symbol" }, [
                                _vm._v(
                                  " " + _vm._s(_vm.getTokenName(row.token))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "targetchainid", label: "To", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "chain-info" }, [
                        _c("img", {
                          staticClass: "chain-icon",
                          attrs: { src: _vm.getChainIcon(row.targetchainid) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "chain-details" }, [
                          _c("div", { staticClass: "chain-name" }, [
                            _vm._v(
                              _vm._s(
                                row.targetchainid == "5570"
                                  ? "Treasurenet"
                                  : "Ethereum"
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "token-amount" },
                            [
                              _c("big-number", {
                                attrs: { number: row.transferAmount },
                              }),
                              _vm._v(" "),
                              _c("span", { staticClass: "token-symbol" }, [
                                _vm._v(
                                  _vm._s(_vm.getTargetTokenSymbol(row.token))
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "transferAmount", label: "Token", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "token-info" }, [
                        _c("img", {
                          staticClass: "token-icon",
                          attrs: { src: _vm.getTokenIcon(row.token) },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "amount-info" }, [
                          _c("span", { staticClass: "token-symbol" }, [
                            _vm._v(_vm._s(_vm.getTokenName(row.token))),
                          ]),
                        ]),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "timestamp", label: "UTC Time", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.moment
                              .utc(row.timestamp)
                              .format("YYYY-MM-DD HH:mm:ss")
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { prop: "status", label: "Status", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c(
                        "div",
                        {
                          staticClass: "status-wrapper",
                          staticStyle: { display: "flex" },
                        },
                        [
                          _c(
                            "el-tag",
                            {
                              staticClass: "status-tag",
                              attrs: { type: _vm.getStatusType(row.status) },
                            },
                            [
                              _c("img", {
                                staticClass: "status-icon",
                                staticStyle: {
                                  width: "0.24rem",
                                  height: "0.24rem",
                                },
                                attrs: { src: _vm.getStatusImage(row.status) },
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.getStatusText(row.status)) +
                                  "\n            "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "Option", align: "left" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      Number(row.status) === 0
                        ? _c(
                            "el-button",
                            {
                              staticClass: "cancel-btn",
                              attrs: { size: "small" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleCancel(row)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n            Cancel Bridging\n          "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("pagination", {
          attrs: { total: _vm.total, page: _vm.page, limit: _vm.pageSize },
          on: {
            "update:total": function ($event) {
              _vm.total = $event
            },
            "update:page": function ($event) {
              _vm.page = $event
            },
            "update:limit": function ($event) {
              _vm.pageSize = $event
            },
            pagination: function ($event) {
              return _vm.getList()
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }